///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

export const closeNotificationFlyoutWindow = () => {
  const notificationMenuIcon = document.getElementById(
    "notification-menu-icon"
  );

  const flyoutOpen =
    document.getElementsByClassName("flyout-window").length !== 0;
  notificationMenuIcon && flyoutOpen && notificationMenuIcon.click();
};

export default closeNotificationFlyoutWindow;
